module.exports = __webpack_public_path__ + "img/icon-source-metadata.327ad2d6.svg";